import instance from './instance';

export const createReaction = data => instance.post(`/reactions`, data);

export const deleteReaction = slug => instance.delete(`/reactions/${slug}`);
